module.exports = __webpack_public_path__ + "img/man.29fb4a1a.svg";